<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm7 md4 lg3 xl3>
        <v-card flat class="elevation-5 pa-5">
          <v-card-title primary-title>
            <h3 class="font-weight-light">
              Вход в систему
            </h3>
          </v-card-title>
          <v-card-text class="pt-5">
            <v-form ref="form">
              <v-text-field
              autocomplete
              name="login"
              v-model="card"
              type="text"
              label="Карта"
              required
              outlined
              append-icon="credit_card"
              @keyup.enter="$refs.ipassword.focus"
              ></v-text-field>
              <v-text-field
              autocomplete
              name="password"
              ref="ipassword"
              v-model="password"
              label="пароль"
              type="password"
              required
              outlined
              append-icon="lock"
              ></v-text-field>
              <br />
              <v-btn block large color="primary" @click="login" :disabled="!valid">
                Продолжить
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
// eslint-disable-next-line
const cardRe = /^[\d]{6,9}$/i
export default {
  name: 'login',
  data: () => ({
    card: null,
    password: null,
  }),
  computed: {
    validCard () {
      if (!this.card) return false
      return cardRe.test(this.card)
    },
    validPassword () {
      if (!this.password) return false
      if (this.password.length < 4) return false
      return true
    },
    valid () {
      return this.validCard && this.validPassword
    }
  },
  methods: {
    async login () {
      try {
        if (!this.valid) return
        const cardid = ('000' + this.card).slice(-9)
        const password = this.password
        this.$store.dispatch('login', { cardid, password, scope: 'teachers' })
      } catch (err) {
        this.$store.dispatch('snack', err)
      }
    }
  },
}
</script>
